<template>
  <div class="app-mnp-in-wrapper content-wrapper">
    <div>
      <h1 class="text-3xl">Rufnummer zu Lidl Connect portieren</h1>

      <div class="container">
        <div v-if="!showStep(successStepName)" id="step-bar" class="container-box">
          <div class="step-bar" role="navigation" aria-label="Aktivierungsprozess">
            <div
              class="step"
              @click="goToStepBefore(beforeStepperData, startStepName)"
              v-bind:class="{ active: showStep(startStepName), 'before-active': beforeStepperData }"
              role="button"
              :aria-current="showStep(startStepName) ? 'step' : false"
              :tabindex="beforeStepperData ? 0 : -1"
              :aria-disabled="!beforeStepperData"
            >
              <span class="icon" aria-hidden="true"></span>
              <span>1. Rufnummernmitnahme</span>
            </div>
            <div
              class="line"
              v-bind:class="{
                active: showStep(startStepName) || showStep(dataStepName) || showStep(summaryStepName)
              }"
              aria-hidden="true"
            ></div>
            <div
              class="step"
              @click="goToStepBefore(beforeStepperSummary, dataStepName)"
              v-bind:class="{ active: showStep(dataStepName), 'before-active': beforeStepperSummary }"
              role="button"
              :aria-current="showStep(dataStepName) ? 'step' : false"
              :tabindex="beforeStepperSummary ? 0 : -1"
              :aria-disabled="!beforeStepperSummary"
            >
              <span class="icon" aria-hidden="true"></span>
              <span>2. Ihre Kundendaten</span>
            </div>
            <div
              class="line"
              v-bind:class="{
                active: showStep(dataStepName) || showStep(summaryStepName)
              }"
              aria-hidden="true"
            ></div>
            <div
              class="step"
              v-bind:class="{ active: showStep(summaryStepName) }"
              role="button"
              :aria-current="showStep(summaryStepName) ? 'step' : false"
              :tabindex="showStep(summaryStepName) ? 0 : -1"
              :aria-disabled="!showStep(summaryStepName)"
            >
              <span class="icon" aria-hidden="true"></span>
              <span>3. Zusammenfassung</span>
            </div>
          </div>
        </div>
        <div v-if="showMNP">
          <MnpInStart
            v-if="showStep(startStepName)"
            :portation-time.sync="portationTime"
            :portation-consent.sync="portationConsent"
            :next-step="dataStepName"
          >
            <template v-for="slot in possibleChildSlotsFor('Start')" v-slot:[`${slot.child}`]>
              <slot :name="`${slot.parent}`"></slot>
            </template>
          </MnpInStart>
          <MnpInData
            v-if="showStep(dataStepName)"
            :portation-time.sync="portationTime"
            :previous-step="startStepName"
            :next-step="summaryStepName"
          >
            <template v-for="slot in possibleChildSlotsFor('Data')" v-slot:[`${slot.child}`]>
              <slot :name="`${slot.parent}`"></slot>
            </template>
          </MnpInData>
          <MnpInSummary v-if="showStep(summaryStepName)" :previous-step="dataStepName" :next-step="successStepName">
            <template v-for="slot in possibleChildSlotsFor('Summary')" v-slot:[`${slot.child}`]>
              <slot :name="`${slot.parent}`"></slot>
            </template>
          </MnpInSummary>
          <MnpInSuccess v-if="showStep(successStepName)" :previous-step="summaryStepName">
            <template v-for="slot in possibleChildSlotsFor('Success')" v-slot:[`${slot.child}`]>
              <slot :name="`${slot.parent}`"></slot>
            </template>
          </MnpInSuccess>
        </div>
        <div v-else>
          <slot name="infoMnpInNotAvailable">
            <h2>Rufnummernmitnahme in diesem Tarif nicht möglich</h2>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MnpInStart, { stepName as startStepName } from '@/components-v2/flows/LIDL/Mnp/MnpIn/Start.vue'
import MnpInData, { stepName as dataStepName } from '@/components-v2/flows/LIDL/Mnp/MnpIn/Data.vue'
import MnpInSummary, { stepName as summaryStepName } from '@/components-v2/flows/LIDL/Mnp/MnpIn/Summary.vue'
import MnpInSuccess, { stepName as successStepName } from '@/components-v2/flows/LIDL/Mnp/MnpIn/Success.vue'
import slotProxy from '@/mixins/slotProxy'
import processWrapper from '@/mixins/processWrapper'
import transaction from '@/mixins/transaction'
import { mapGetters, mapMutations } from 'vuex'
import gql from 'graphql-tag'
import { wrapQuery } from '../../../../../helper/wrapGQLQuery'
import extraData from '../../../../../mixins/extraData'

export default {
  name: 'MnpInWrapper',
  import: {
    startStepName,
    dataStepName,
    summaryStepName,
    successStepName
  },
  data() {
    return {
      portationTime: 'CONTRACT_END',
      portationConsent: false,
      tariffs: null
    }
  },
  methods: {
    goToStepBefore(active, step) {
      if (active) {
        this.goToStep(step)
      }
    },
    ...mapMutations('mnpIn', ['goToStep'])
  },
  computed: {
    beforeStepperData: function() {
      return this.beforeStepperSummary || this.showStep(dataStepName)
    },
    beforeStepperSummary: function() {
      return this.showStep(summaryStepName)
    },
    ...mapGetters('mnpIn', ['showMnpInView']),
    tariffsExtra: function() {
      return this.extraData.find(item => item.id === this.tariffs?.bookedTariff?.tariffId)
    },
    showMNP: function() {
      return this.tariffsExtra?.type !== 'year'
    }
  },
  apollo: {
    tariffs: function() {
      return wrapQuery(
        gql`
          query MnpIn {
            tariffs {
              bookedTariff {
                tariffId
              }
            }
          }
        `,
        this,
        'tariffs'
      )
    }
  },
  components: {
    MnpInStart,
    MnpInData,
    MnpInSummary,
    MnpInSuccess
  },
  mixins: [transaction('mnpIn'), slotProxy(['Stepper']), processWrapper('showMnpInView'), extraData()]
}
</script>
